import { gql } from '@apollo/client';

export const GET_FILTER_OPTION_DATA = gql`
    query {
        rfqProcessingChannels {
            id
            name
            automationEnabled
        }

        orderProcessingChannels {
            id
            name
            automationEnabled
        }

        orderConfirmationProcessingChannels {
            id
            name
            automationEnabled
        }

        invoiceProcessingChannels {
            id
            name
            automationEnabled
        }

        deliveryNoteProcessingChannels {
            id
            name
            automationEnabled
        }

        listOfServicesProcessingChannels {
            id
            name
            automationEnabled
        }

        universalProcessingChannels {
            id
            name
            automationEnabled
        }

        viewer {
            customer {
                isRfqsEnabled
                isOrdersEnabled
                isOrderConfirmationsEnabled
                isInvoicesEnabled
                isDeliveryNotesEnabled
                isUniversalEnabled
            }
        }

        users(From: 0, size: 1000) {
            users {
                id
                email
                firstName
                lastName
                groups {
                    id
                    name
                }
                teams {
                    id
                    name
                }
            }
            totalCount
        }
    }
`;

export const GET_DAILY_METRICS = gql`
    query ($documentType: DocumentTypeEnum!, $startDate: Date!, $endDate: Date!, $channelIds: [UUID]!) {
        dailyMetrics(documentType: $documentType, startDate: $startDate, endDate: $endDate, channelIds: $channelIds) {
            date
            finishedCount
            assistedCount
            discardedCount
            deletedCount
            automatedCount
            headerAutomatedCount
            headerAssistedCount
            headerTotalCount
            headerAutomationRatio
            lineItemsAutomatedCount
            lineItemsAssistedCount
            lineItemsTotalCount
            lineItemsAutomationRatio
            medianAssistanceTime
            totalAssistanceTime
            totalAssistanceTimeBeforeWorkist
            averageAssistanceTimePerDocumentBeforeWorkist
            trackedCount
        }
    }
`;

export const GET_TOP_ASSISTANCE_REASONS = gql`
    query ($documentType: DocumentTypeEnum!, $startDate: Date!, $endDate: Date!, $channelIds: [UUID]!) {
        topAssistanceReasons(
            documentType: $documentType
            startDate: $startDate
            endDate: $endDate
            channelIds: $channelIds
        ) {
            reason
            fieldName
            percentage
            sampleUrls
        }
    }
`;

// Email categories accumulated + overtime + top categories
export const SMART_INBOX_EMAIL_CATEGORY_DISTRIBUTION = gql`
    query SmartInboxEmailCategoryDistribution($integrationIds: [UUID!]!, $startDate: Date!, $endDate: Date!) {
        smartInboxEmailCategoryDistribution(integrationIds: $integrationIds, startDate: $startDate, endDate: $endDate) {
            categories {
                categoryName
                count
                percentage
                trendPercentagePoints
            }
            daily {
                date
                categoryName
                count
            }
            topCategories {
                categoryName
                count
                percentage
                trendPercentagePoints
            }
        }
    }
`;

// Performance metrics including e2e automation and recognition rates
export const SMART_INBOX_PERFORMANCE_METRICS = gql`
    query SmartInboxPerformanceMetrics($integrationIds: [UUID!]!, $startDate: Date!, $endDate: Date!) {
        smartInboxPerformanceMetrics(integrationIds: $integrationIds, startDate: $startDate, endDate: $endDate) {
            recognitionRate {
                count
                totalCount
                rate
                trendPercentagePoints
            }
            automationRate {
                count
                totalCount
                rate
                trendPercentagePoints
            }
            manualForwardingRate {
                count
                totalCount
                rate
                trendPercentagePoints
            }
        }
    }
`;

// Smart inbox share at customer level
export const SMART_INBOX_SHARE = gql`
    query SmartInboxShare($startDate: Date!, $endDate: Date!) {
        smartInboxShare(startDate: $startDate, endDate: $endDate) {
            smartInboxCount
            nonSmartInboxCount
            totalCount
            smartInboxPercentage
            trendPercentagePoints
            totalCountTrendPercentage
            daily {
                date
                smartInboxCount
                nonSmartInboxCount
            }
        }
    }
`;
